import FeedbackContainer from "../components/feedback-container"
import FeedbackHeadline from "../components/feedback-headline"
import FeedbackPoints from "../components/feedback-points"
import Leaderboard from "../components/leaderboard"
import LeaderboardItem from "../components/leaderboard-item"
import ResponsiveContainer from "../components/responsive-container"
import ResponsiveContent from "../components/responsive-content"
import { useMessages } from "../language/language"
import "./leaderboard-frame.less"
import { emptyGuid } from "utils/helpers"
import { useEffect, useMemo } from "react"
import { usePlayState } from "play/hooks/use-play-state"
import { applyTimerToState, switchToNextScreenReducer } from "play/reducers"

function computeKey(id: string | null | undefined, name: string) {
  return `${id || emptyGuid}_${name}`
}

export default function LeaderboardFrame() {
  // const COUNT_STUDENTS_AROUND_ME = 10;
  // const MAX_STUDENTS_IN_LEADERBOARD = 50;

  const {
    loggedUser,
    fullName,
    leaderboard,
    feedbackDurationInSeconds,
    lastScreenPoints,
    isTeacherUrl,
    lastScreenIsCorrect,
    modifyState,
  } = usePlayState()

  const myId = loggedUser?.id
  const isCorrect = lastScreenIsCorrect || isTeacherUrl
  const msg = useMessages()
  // const [state, setState] = useState( {
  //   countStudentsAroundMe: 3,
  //   isLeaderboardOverflowing: false
  // })

  const maxStudentsInLeaderboard = 50

  // useLayoutEffect(() => {
  //   function update() {
  //     const or = window.screen.orientation
  //     // console.log(or)
  //     let newCount: number
  //     if (window.innerHeight < 450) {
  //       newCount = 3
  //     } else if (window.innerHeight < 600) {
  //       newCount = 5
  //     } else if (window.innerHeight < 800) {
  //       newCount = 7
  //     } else if (window.innerHeight < 1000) {
  //       newCount = 9
  //     } else  {
  //       newCount = 15
  //     }
  //
  //     newCount = 99
  //
  //     setState(prev => ({...prev, countStudentsAroundMe: newCount}))
  //   }
  //
  //   update();
  //
  //   window.addEventListener('resize', update)
  //   window.addEventListener('orientationchange', update)
  //   return () => {
  //     window.removeEventListener('orientationchange', update)
  //     window.removeEventListener('resize', update)
  //   }
  // }, [])

  // const lama = isCorrect ? LamaHappy : LamaSurprised;
  const studentKey = computeKey(myId, fullName || "")

  useEffect(() => {
    setTimeout(() => {
      modifyState((state) => {
        state.nextScreenButtonIsVisible = true
        state.internalPage = null
        const resp = state.screenFinishedResponse
        state.screenFinishedResponse = null
        if (!resp) {
          return console.error("ScreenFinishedResponse is empty")
        }

        applyTimerToState(state, resp)
        switchToNextScreenReducer(state, resp)
      })
    }, feedbackDurationInSeconds * 1000)
  }, [])

  const myLeaderboard = useMemo(() => {
    // console.log('computing leaderboard')

    const sorted = leaderboard
      .slice()
      .sort((x, y) => y.points - x.points)
      .map((x, idx) => ({
        ...x,
        pos: idx,
        isSelected: computeKey(x.id, x.fullName) === studentKey,
      }))
    const top = sorted.filter((_, idx) => idx < maxStudentsInLeaderboard)
    if (isTeacherUrl) {
      return top
    } else {
      let studentLeaderboard = sorted
      const selectedIdx = studentLeaderboard.findIndex((x) => x.isSelected)
      if (selectedIdx !== -1) {
        // studentLeaderboard = studentLeaderboard
        //   .filter(item =>
        //     item.pos >= selectedIdx - state.countStudentsAroundMe
        //     && item.pos <= selectedIdx + state.countStudentsAroundMe);
      } else {
        studentLeaderboard = top
      }
      return studentLeaderboard
    }
  }, [
    leaderboard,
    studentKey,
    isTeacherUrl,
    /*state.countStudentsAroundMe,*/ maxStudentsInLeaderboard,
  ])

  let className = "leaderboard-frame"
  let feedbackText: string
  const pointsText = msg.feedbackPointsToString(lastScreenPoints)

  if (isCorrect) {
    className += " correct"
    feedbackText = msg.feedback_correct
  } else {
    className += " incorrect"
    feedbackText = msg.feedback_incorrect
  }

  return (
    <article className={className}>
      {!isTeacherUrl && (
        <div className="top">
          <FeedbackContainer>
            <FeedbackHeadline className="feedback">
              {feedbackText}
            </FeedbackHeadline>
            <FeedbackPoints isCorrect={isCorrect}>{pointsText}</FeedbackPoints>
          </FeedbackContainer>
        </div>
      )}
      <ResponsiveContainer className="rest" centerContents={false}>
        <ResponsiveContent className="leaderboard-container">
          <Leaderboard>
            <div className="vert-center-container">
              {myLeaderboard.map((item) => (
                <LeaderboardItem
                  key={computeKey(item.id, item.fullName)}
                  place={item.pos + 1}
                  name={item.fullName}
                  isSelected={item.isSelected}
                  isCorrect={isCorrect}
                  pointsText={msg.pointsToString(item.points)}
                />
              ))}
            </div>
          </Leaderboard>
          {/*<div className="leaderboard-bottom">*/}
          {/*  <img src={lama} alt={feedbackText} />*/}
          {/*</div>*/}
        </ResponsiveContent>
      </ResponsiveContainer>
    </article>
  )
}
